import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';
import { VehicleBrand } from 'src/app/domain/core/vehicle-brand.model';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-head',
  imports: [CommonModule, HeaderComponent],
  templateUrl: './head.component.html'
})
export class HeadComponent implements OnInit, OnDestroy {
  @Input() brand: VehicleBrand = VehicleBrand.TOYOTA;
  @Input() userName?: string = undefined;

  noMarginTop = false;
  isDigSigWizard = false;
  currentUrl = '';

  private routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl = event.urlAfterRedirects;
        this.checkNoMarginTop();
        this.checkIsDigSigWizard();
      });

    this.currentUrl = this.router.url;
    this.checkNoMarginTop();
  }

  private checkNoMarginTop() {
    const firstSegment = this.currentUrl.split('/').filter(Boolean)[0] ?? '';
    this.noMarginTop = firstSegment === 'consentViaEmail' || firstSegment === 'digSig' || firstSegment === 'consentViaWizard';
  }

  private checkIsDigSigWizard() {
    const firstSegment = this.currentUrl.split('/').filter(Boolean)[0] ?? '';
    this.isDigSigWizard = firstSegment === 'digSig';
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }
}
